export const FreeShippingIcon = ({
  width = 48,
  height = 48,
  className,
  title = "Free Shipping",
  ...rest
}: IconProps & React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 48 48"
      fill="none"
      className={className}
      {...rest}>
      <title>{title}</title>
      <path
        d="M15.4184 33.0581L23.2682 37.2614C23.5223 37.436 23.8403 37.4831 24.1334 37.3903L37.3759 33.5897C37.7904 33.4561 38.0712 33.0691 38.0712 32.6302V26.2089C38.0712 26.0327 37.9699 25.8738 37.8124 25.7983L29.2174 21.7508L14.7559 25.4239L14.985 32.2605C14.9959 32.5814 15.155 32.8772 15.4184 33.0581Z"
        stroke="#00226A"
        strokeMiterlimit="10"
      />
      <path
        d="M14.7557 25.4254L8.50244 17.9864C8.12359 17.5349 8.33874 16.8396 8.90622 16.687L22.0301 13.1555C22.3419 13.0721 22.6709 13.1854 22.8689 13.4417L29.2188 21.7539"
        stroke="#00226A"
        strokeMiterlimit="10"
      />
      <path
        d="M23.042 29.9071L15.2094 25.5639C15.119 25.5135 15.1361 25.3782 15.2359 25.3531L29.2189 21.7523L37.6423 25.718C37.7903 25.7872 37.7733 26.0059 37.6158 26.0499L23.6874 29.9826C23.4707 30.044 23.24 30.0173 23.0435 29.9071H23.042Z"
        fill="#00226A"
        stroke="#00226A"
        strokeMiterlimit="10"
      />
      <path
        d="M39.8147 20.7282L38.8262 20.9862C38.6017 21.0444 38.4412 21.241 38.4272 21.4739L38.3647 22.5011C38.3522 22.6993 38.0967 22.7653 37.9922 22.5986L37.445 21.7303C37.3202 21.5336 37.085 21.4392 36.862 21.4974L35.8735 21.7554C35.6832 21.8042 35.5415 21.5808 35.6662 21.4282L36.3147 20.6338C36.4612 20.4545 36.4767 20.1981 36.3537 20.0015L35.8065 19.1331C35.7005 18.9664 35.8687 18.7603 36.0512 18.8326L37.0007 19.2102C37.2157 19.2951 37.4605 19.2322 37.6087 19.0513L38.2572 18.2569C38.382 18.1043 38.6267 18.2018 38.6157 18.4001L38.5535 19.4273C38.5395 19.6601 38.675 19.8756 38.8902 19.9605L39.8397 20.3381C40.022 20.4105 40.0065 20.6763 39.8162 20.7251L39.8147 20.7282Z"
        fill="#5DCDFF"
      />
      <path
        d="M30.3003 10.154L30.5529 11.1513C30.6106 11.3779 30.8055 11.5399 31.0362 11.5556L32.0542 11.6217C32.2507 11.6343 32.3146 11.8923 32.1493 11.9977L31.2872 12.5483C31.0923 12.6725 30.9988 12.9101 31.0549 13.1366L31.3075 14.1339C31.3558 14.3258 31.1329 14.4674 30.9816 14.3415L30.1974 13.684C30.0197 13.5346 29.7671 13.5188 29.5707 13.6431L28.7086 14.1937C28.5433 14.2991 28.3391 14.1292 28.4123 13.9451L28.7896 12.9887C28.8754 12.7716 28.813 12.5246 28.6353 12.3752L27.8511 11.7177C27.6999 11.5918 27.7981 11.3433 27.993 11.3574L29.011 11.4235C29.2418 11.4392 29.4553 11.3024 29.5411 11.0853L29.9184 10.1289C29.9916 9.9448 30.2536 9.96211 30.3019 10.154H30.3003Z"
        fill="#5DCDFF"
      />
      <path
        d="M20.4926 16.0935L20.3616 17.1145C20.332 17.3457 20.159 17.5313 19.9313 17.5754L18.9289 17.7657C18.7356 17.8019 18.7028 18.0662 18.879 18.1511L19.8004 18.5916C20.0093 18.6907 20.1309 18.9156 20.1013 19.1469L19.9703 20.1678C19.9454 20.3644 20.1839 20.4777 20.318 20.3346L21.018 19.5858C21.177 19.4159 21.4249 19.3687 21.6338 19.4694L22.5552 19.9098C22.7329 19.9948 22.9138 19.8013 22.8187 19.6267L22.3291 18.7237C22.2184 18.5192 22.2512 18.266 22.4086 18.0961L23.1086 17.3473C23.2427 17.2041 23.1164 16.9697 22.9247 17.0059L21.9222 17.1963C21.6946 17.2387 21.4654 17.1302 21.3547 16.9257L20.8652 16.0228C20.7717 15.8497 20.5113 15.8985 20.4864 16.0951L20.4926 16.0935Z"
        fill="#5DCDFF"
      />
    </svg>
  );
};
